import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/TestimonialsPage/TestimonialsPage.tsx");
